// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"097318fb","239":"12034f6c","455":"d1f340bc"}[chunkId] + ".chunk.js";
};